import React from 'react';
import PropTypes from 'prop-types';

import ProductTile from '../../localcontent/yourtitles/ProductTile';
import { createLibxchangeProductDetailLink } from '../../localcontent/yourtitles/utils/product-detail-link-helpers';
import { DISPLAY_TYPE_LIST, DISPLAY_TYPE_MINIMAL } from '../../../store/displayType/types';
import stringContainingInteger from '../../../shared/utils/custom-proptypes/stringContainingInteger';
import ListItem from '../../localcontent/yourtitles/ListItem';

const LibxchangeProductElement = props => {
    const productLinkUri = createLibxchangeProductDetailLink(props.product.id);
    const isLibxchange = true;
    const isYourTitle = false;
    const isInCollection = false;

    if (props.displayType === DISPLAY_TYPE_LIST) {
        return (
            <ListItem
                isYourTitle={isYourTitle}
                isLibxchange={isLibxchange}
                isInCollection={isInCollection}
                productLinkUri={productLinkUri}
                shopLanguage={props.shopLanguage}
                {...props}
            />
        );
    } else if (props.displayType === DISPLAY_TYPE_MINIMAL) {
        return (
            <ProductTile
                isYourTitle={isYourTitle}
                isLibxchange={isLibxchange}
                isInCollection={isInCollection}
                productLinkUri={productLinkUri}
                shopLanguage={props.shopLanguage}
                {...props}
            />
        );
    } else {
        return <div />;
    }
};

export default LibxchangeProductElement;

LibxchangeProductElement.defaultProps = {
    displayType: DISPLAY_TYPE_MINIMAL
};

LibxchangeProductElement.propTypes = {
    displayType: PropTypes.oneOf([DISPLAY_TYPE_LIST, DISPLAY_TYPE_MINIMAL]).isRequired,
    updateProductInProductGroup: PropTypes.func,
    onAddToCollection: PropTypes.func.isRequired,
    id: stringContainingInteger,
    product: PropTypes.object.isRequired,
    hoverListener: PropTypes.func
};
